export const COOKIE_CONSENT_STORAGE_KEY = 'podcastbery_cookie_consent_v1'
export const COOKIE_SETTINGS_EVENT = 'podcastbery:open-cookie-settings'

export type CookieConsentValue = 'accepted' | 'declined'

const METRIKA_ID = 98604406

type MetrikaWindow = Window & {
	ym?: (...args: any[]) => void
}

let metrikaStarted = false

export const getCookieConsent = (): CookieConsentValue | null => {
	const value = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
	return value === 'accepted' || value === 'declined' ? value : null
}

export const enableAnalytics = () => {
	if (metrikaStarted || document.getElementById('yandex-metrika-script')) return

	metrikaStarted = true
	const metrikaWindow = window as MetrikaWindow
	metrikaWindow.ym =
		metrikaWindow.ym ||
		function (...args: any[]) {
			;(metrikaWindow.ym as any).a = (metrikaWindow.ym as any).a || []
			;(metrikaWindow.ym as any).a.push(args)
		}

	const script = document.createElement('script')
	script.id = 'yandex-metrika-script'
	script.async = true
	script.src = 'https://mc.yandex.ru/metrika/tag.js'
	document.head.appendChild(script)

	metrikaWindow.ym(METRIKA_ID, 'init', {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
		webvisor: true,
	})
}

export const openCookieSettings = () => {
	window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))
}
